/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tag } from '../../models/tag';

export interface TagsControllerFindAll$Params {
}

export function tagsControllerFindAll(http: HttpClient, rootUrl: string, params?: TagsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Tag>>> {
  const rb = new RequestBuilder(rootUrl, tagsControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Tag>>;
    })
  );
}

tagsControllerFindAll.PATH = '/tags';
